import { render, staticRenderFns } from "./ProductAccordeon.vue?vue&type=template&id=3a4977d5&"
import script from "./ProductAccordeon.vue?vue&type=script&lang=ts&"
export * from "./ProductAccordeon.vue?vue&type=script&lang=ts&"
import style0 from "./ProductAccordeon.vue?vue&type=style&index=0&id=3a4977d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports